// frontend/book-app-frontend/src/components/CommentManagement/translations.js
const translations = {
  pt: {
    // Títulos e navegação
    commentManagement: 'Gerenciamento de Comentários',
    allComments: 'Todos os Comentários',
    myComments: 'Meus Comentários',
    myChaptersComments: 'Comentários dos Meus Capítulos',
    myBooksComments: 'Comentários dos Meus Livros',
    
    // Ações
    createNewComment: 'Criar Novo Comentário',
    editComment: 'Editar Comentário',
    edit: 'Editar',
    delete: 'Excluir',
    cancel: 'Cancelar',
    createComment: 'Criar Comentário',
    updateComment: 'Atualizar Comentário',
    
    // Formulário
    selectChapter: 'Selecionar Capítulo',
    commentText: 'Texto do Comentário',
    enterCommentText: 'Digite o texto do comentário...',
    pageNumber: 'Número da Página',
    enterPageNumber: 'Digite o número da página',
    suggestionType: 'Tipo de Sugestão',
    enterSuggestionType: 'Digite o tipo de sugestão',
    
    // Detalhes
    createdBy: 'Criado por',
    chapter: 'Capítulo',
    
    // Estados e mensagens
    loadingComments: 'Carregando comentários...',
    noCommentsFound: 'Nenhum comentário encontrado',
    
    // Paginação
    page: 'Página',
    of: 'de',
    total: 'total',
    
    // Validações e erros
    commentTextRequired: 'O texto do comentário é obrigatório',
    failedToFetchComments: 'Falha ao buscar comentários',
    failedToLoadChapters: 'Falha ao carregar capítulos',
    failedToCreateComment: 'Falha ao criar comentário',
    failedToUpdateComment: 'Falha ao atualizar comentário',
    failedToDeleteComment: 'Falha ao excluir comentário',
    
    // Sucessos
    commentCreatedSuccessfully: 'Comentário criado com sucesso!',
    commentUpdatedSuccessfully: 'Comentário atualizado com sucesso!',
    commentDeletedSuccessfully: 'Comentário excluído com sucesso!',

    // Filtros
    filters: 'Filtros',
    startDate: 'Data de Início',
    endDate: 'Data de Fim',
    clearFilters: 'Limpar Filtros',
    noCommentsWithFilters: 'Nenhum comentário encontrado com os filtros aplicados',

    // Paginação detalhada
    showing: "Mostrando",
    commentsLow: "comentários",

    // Mensagens de confirmação
    confirmDelete: 'Confirmar Exclusão',
    confirmDeleteMessage: 'Tem certeza que deseja excluir este comentário?',

    //
    download: 'Baixar',

    //
    confirmReopen: 'Confirmar Reabertura',
    commentManagerDeleted: 'Gerenciamento de Comentário Excluído',
    reopen: 'Reabrir',
    confirmReopenMessage: 'Tem certeza que deseja reabrir este comentário?',
    commentReopenedSuccessfully: 'Comentário reaberto com sucesso!',
    deletedByIA: 'Comentário excluído automaticamente pela IA.',
    deletedByEditor: 'Comentário excluído pelo editor do livro.',
  },
  
  en: {
    // Títulos e navegação
    commentManagement: 'Comment Management',
    allComments: 'All Comments',
    myComments: 'My Comments',
    myChaptersComments: 'My Chapters Comments',
    myBooksComments: 'My Books Comments',
    
    
    // Ações
    createNewComment: 'Create New Comment',
    editComment: 'Edit Comment',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    createComment: 'Create Comment',
    updateComment: 'Update Comment',
    
    // Formulário
    selectChapter: 'Select Chapter',
    commentText: 'Comment Text',
    enterCommentText: 'Enter comment text...',
    pageNumber: 'Page Number',
    enterPageNumber: 'Enter page number',
    suggestionType: 'Suggestion Type',
    enterSuggestionType: 'Enter suggestion type',

    // Detalhes
    createdBy: 'Created by',
    chapter: 'Chapter',
    
    // Estados e mensagens
    loadingComments: 'Loading comments...',
    noCommentsFound: 'No comments found',
    
    // Paginação
    page: 'Page',
    of: 'of',
    total: 'total',
    
    // Validações e erros
    commentTextRequired: 'Comment text is required',
    failedToFetchComments: 'Failed to fetch comments',
    failedToLoadChapters: 'Failed to load chapters',
    failedToCreateComment: 'Failed to create comment',
    failedToUpdateComment: 'Failed to update comment',
    failedToDeleteComment: 'Failed to delete comment',
    
    // Sucessos
    commentCreatedSuccessfully: 'Comment created successfully!',
    commentUpdatedSuccessfully: 'Comment updated successfully!',
    commentDeletedSuccessfully: 'Comment deleted successfully!',

    // Filtros
    filters: 'Filters',
    startDate: 'Start Date',
    endDate: 'End Date',
    clearFilters: 'Clear Filters',
    noCommentsWithFilters: 'No comments found with applied filters',

    // Paginação detalhada
    showing: "Showing",
    commentsLow: "comments",

    // Mensagens de confirmação
    confirmDelete: 'Confirm Deletion',
    confirmDeleteMessage: 'Are you sure you want to delete this comment?',

    //
    download: 'Download',

    // Reabrir
    confirmReopen: 'Confirm Reopen',
    commentManagerDeleted: 'Comment Manager Deleted',
    reopen: 'Reopen',
    confirmReopenMessage: 'Are you sure you want to reopen this comment?',
    commentReopenedSuccessfully: 'Comment reopened successfully!',
    deletedByIA: 'Comment automatically deleted by AI.',
    deletedByEditor: 'Comment deleted by the book editor.',
    
  }
};

export default translations;

